import typeahead from '@app/adapters/typeahead'

import { SyncAutoComplete } from '@app/application/miscellaneous/handlers/autocomplete'

export default (): void => {
  window.onDomLoad(function ($dom) {
    const textFields = $dom[0].querySelectorAll(
      '[data-behaviour="report-template-category-autocomplete"]'
    )

    textFields.forEach((textField) => {
      if (textField instanceof HTMLInputElement) {
        const parsedCategories = textField.dataset.categories
          ? (JSON.parse(textField.dataset.categories) as string[])
          : []

        if (parsedCategories && Array.isArray(parsedCategories)) {
          new SyncAutoComplete({
            typeahead,
            element: textField,
            data: parsedCategories,
          })
        }
      }
    })
  })
}
